module.exports = __webpack_public_path__ + "static/media/FeaturedIn_Desktop_EN.2fd740df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FeaturedIn_Desktop_EN.png
// module id = 576
// module chunks = 0